import IconClose from "components/Icon/IconClose";
import Image from "next/image";
import { motion } from "framer-motion";
import LoaderFadeInOut from "components/Loader/LoaderFadeInOut";
import { Limit } from "./Limit";
import { useEffect, useRef, useState } from "react";
import { SidebarDesktop } from "./SidebarDesktop";
import { AudioVisualizerNxtx } from "./AudioVisualizerNxtx";
import { trackEventGA, trackEventGTM } from "lib/amplitude";
import { BottomNavMobile } from "./BottomNavMobile";
import { useSystemStore } from "components/PageHeader/systemStore";
import { useAuthStore } from "modules/Auth/authStore";
import { AudioVisualizer } from "./AudioVisualizer";
import { IconNexaText } from "components/Icon/IconNexaText";

export const AvatarDesktop = ({
  chatModeTenant,
  nxtxTenant,
  sendInterrupt,
  sendText,
  VisualAudioContext,
  handlePasskeySubmit,
  isCloseWhenLoading,
  setIsCloseWhenLoading,
  keywordChipsData,
  isVisible,
  handleInterrupt,
  dataAvatar,
  isAnyFiltered,
  isKeywordsSearched,
  isScrolled,
  handleMinimize,
  isSmaller,
  mediaStream,
  isMediaReady,
  setIsMediaReady,
  startSession,
  endSession,
  isLoadingSession,
  stream,
  toggleSidebar,
  showSidebar,
  toggleSummarySidebar,
  showSummarySidebar,
  toggleQuizSidebar,
  showQuizSidebar,
  chat,
  lastDisplayedDate,
  currentUser,
  handleCopyText,
  copySuccess,
  chatEndRef,
  summaryRecap,
  summaryEndRef,
  scrollToTop,
  handleBigger,
  handleSmaller,
  volumes,
  isVoiceChatActive,
  isMuted,
  handleCloseVoiceChat,
  handleStartVoiceChat,
  disabledMic,
  micIsLoading,
  modeIsLoading,
  remainingDuration,
  maxDuration,
  formatTime,
  showLimitDesc,
  setShowLimitDesc,
  isRequestSent,
  setIsRequestSent,
  isIncreaseLimit,
  setIsIncreaseLimit,
  limitChecked,
  setLimitChecked,
  showAllSidebar,
  setShowAllSidebar,
  handleFullScreen,
  showToast,
  activeTab,
  setActiveTab,
  handleRequestQuota,
  chatMode,
  isUserTalking,
  textValue,
  setTextValue,
  handleSpeakText,
  isLoadingRepeat,
  handleChangeChatMode,
  saveChat,
  textQuiz,
  setTextQuiz,
  handleSpeakQuiz,
}) => {
  const [showAdditionalContent, setShowAdditionalContent] = useState(true);

  const handleSubmit = (isChip?: boolean, textToSubmit?: string) => {
    const textToCheck = isChip ? textToSubmit : textValue;

    if (!textToCheck || textToCheck.trim() === "") {
      return;
    }

    trackEventGTM({
      event: "gaia_text_submit_a",
      property: {
        user_id: currentUser?.id ?? "",
      },
    });

    trackEventGA({
      event: "gaia_text_submit_a",
      property: {
        user_id: currentUser?.id ?? "",
      },
    });

    if (isChip) {
      handleSpeakText(textToSubmit);
    } else {
      handleSpeakText();
    }

    setTextValue("");
  };

  useEffect(() => {
    setShowAdditionalContent(false);
    const timeout = setTimeout(() => {
      setShowAdditionalContent(true);
    }, 2000);

    return () => clearTimeout(timeout);
  }, [isScrolled]);

  const containerRef = useRef(null);
  const videoContainerRef = useRef(null);

  useEffect(() => {
    Promise.all([import("gsap"), import("gsap/ScrollTrigger")]).then(
      ([{ default: gsap }, { ScrollTrigger }]) => {
        gsap.registerPlugin(ScrollTrigger);

        const videoContainer = videoContainerRef.current;

        if (!stream && !isLoadingSession) {
          gsap.set(videoContainer, {
            width: "0px",
            bottom: 0,
            right: 0,
            position: "fixed",
          });
        } else if ((stream || isLoadingSession) && isScrolled) {
          gsap.set(videoContainer, {
            width: "100%",
            bottom: 0,
            right: 0,
            position: "fixed",
          });
        } else {
          gsap.set(videoContainer, {
            width: "22vw",
            bottom: 20,
            right: 20,
            position: "fixed",
          });
        }

        if (stream || isLoadingSession) {
          const tl = gsap.timeline({
            defaults: { duration: 1, ease: "power2.inOut" },
          });

          if (isScrolled) {
            tl.to(videoContainer, {
              width: "22vw",
              bottom: 20,
              right: 20,
              position: "fixed",
            });
          } else {
            tl.to(videoContainer, {
              width: "100%",
              bottom: 0,
              right: 0,
              zIndex: 40,
              position: "fixed",
            });
          }

          tl.play();

          return () => {
            tl.kill();
          };
        }
      }
    );
  }, [isScrolled, isSmaller, stream, isLoadingSession]);

  const [isQuizStarted, setIsQuizStarted] = useState(false);

  const excludedWords = [
    "ketentuan",
    "trigger",
    "skor",
    "grade",
    "passing",
    "penilaian",
    "lolos",
    "gaia",
    "jika anda",
    "memiliki pertanyaan",
  ];

  const includeWords = [":"];

  const filterChatWithQuestion = saveChat.chat.filter((item) => {
    const avatarText = item.avatar?.toLowerCase();

    const containsExcludedWord = excludedWords.some((word) =>
      avatarText.includes(word)
    );

    const containsIncludeWord = includeWords.some((word) =>
      avatarText.includes(word)
    );

    return (
      avatarText.includes("pertanyaan") &&
      containsIncludeWord &&
      !containsExcludedWord
    );
  });

  // const fetchHandleSpeakQuiz = async () => {
  //   await handleSpeakQuiz();
  // };

  // useEffect(() => {
  //   if (
  //     saveChat.chat.length % 3 === 0 &&
  //     saveChat.chat.length !== 0 &&
  //     !isQuizStarted
  //   ) {
  //     setTextQuiz(`
  //       Quiz Trigger Conditions:

  //       - Apakah pengguna telah mengajukan tiga pertanyaan pada topik diskusi yang sama terkait pekerjaan profesional?
  //       - Apakah pengguna telah beralih ke topik lain, meskipun mereka hanya mengajukan satu pertanyaan relevan pada topik sebelumnya?

  //       Jika ya, maka GAIA akan memulai sesi Quiz.
  //     `);

  //     setTimeout(() => {
  //       fetchHandleSpeakQuiz();
  //     }, 3000);
  //   }
  // }, [saveChat.chat]);

  useEffect(() => {
    if (filterChatWithQuestion.length > 0) {
      setIsQuizStarted(true);
    }
  }, [filterChatWithQuestion.length]);

  useEffect(() => {
    if (!stream) {
      setIsQuizStarted(false);
    }
  }, [stream]);

  const [isShowInfo, setIsShowInfo] = useState(false);
  const [isShowModeInfo, setIsShowModeInfo] = useState(false);
  const [isShowEndButtonInfo, setIsShowEndButtonInfo] = useState(false);
  const [isShowConversationInfo, setIsShowConversationInfo] = useState(false);

  useEffect(() => {
    setIsShowModeInfo(false);
    setIsShowEndButtonInfo(false);
  }, [isScrolled]);

  const theme = useSystemStore((state) => state.theme);

  const { tenantData } = useAuthStore();

  const sidebarAnimate = {
    open: {
      width: "30%",
      transition: {
        damping: 40,
      },
    },
    closed: {
      width: "0px",
      transition: {
        damping: 40,
      },
    },
  };

  const videoClass = `w-full ${
    isScrolled && !showSidebar
      ? "h-full rounded-xl aspect-[9/16]"
      : isScrolled && showSidebar
      ? "h-[30%] rounded-t-xl aspect-16/9"
      : "h-[calc(100vh-68px)]"
  } object-cover transition-all duration-500 ease-in-out ${
    !stream && !isLoadingSession && "hidden"
  }`;

  return (
    <>
      {((!stream && !isLoadingSession) ||
        ((stream || isLoadingSession) && isCloseWhenLoading)) && (
        <>
          {isShowInfo && !stream && (
            <div className="fixed bottom-36 right-140 z-[100]">
              <div
                className="relative max-w-[347px] text-black p-16 rounded-xl"
                style={{
                  backdropFilter: "blur(40px)",
                  boxShadow: "0px 4px 6px 0px #0000000D",
                  backgroundColor: theme == "light" ? "#000000CC" : "#FFFFFFCC",
                }}
              >
                <p
                  className="text-b2 font-light"
                  style={{
                    color: theme == "light" ? "#FFFFFF" : "#19093A",
                  }}
                >
                  Coach AI interaktif yang memberikan bimbingan, pelatihan
                  personal, dan feedback secara real-time
                </p>
                <div
                  className="absolute top-1/2 -right-[9.5px] -translate-y-1/2 w-0 h-0 border-t-[10px] border-t-transparent border-b-[10px] border-b-transparent"
                  style={{
                    borderLeft:
                      theme == "light"
                        ? "10px solid #000000CC"
                        : "10px solid #FFFFFFCC",
                  }}
                ></div>
              </div>
            </div>
          )}

          <div className="fixed bottom-24 right-20 z-50">
            <div
              className="relative cursor-pointer"
              onMouseEnter={() => setIsShowInfo(true)}
              onMouseLeave={() => setIsShowInfo(false)}
              onClick={
                remainingDuration > 0
                  ? nxtxTenant
                    ? handlePasskeySubmit
                    : startSession
                  : (e) => {
                      e.stopPropagation();

                      trackEventGTM({
                        event: "gaia_quota_s",
                        property: {
                          user_id: currentUser?.id ?? "",
                          is_logged_in: !!currentUser,
                          session_id: dataAvatar?.session_id,
                          screen_state: isScrolled ? "minimize" : "maximize",
                        },
                      });

                      trackEventGA({
                        event: "gaia_quota_s",
                        property: {
                          user_id: currentUser?.id ?? "",
                          is_logged_in: !!currentUser,
                          session_id: dataAvatar?.session_id,
                          screen_state: isScrolled ? "minimize" : "maximize",
                        },
                      });

                      setShowLimitDesc(!showLimitDesc);
                    }
              }
            >
              <div
                style={{
                  background:
                    "linear-gradient(135deg, #883CFF 25%, #2F0F57 100%)",
                }}
                className="h-[104px] w-[104px] rounded-20 flex flex-col items-center justify-center gap-4"
              >
                <video
                  className="border-2 border-white_to_white w-[98px] h-[72px] rounded-[19px] object-cover"
                  src={`/images/${
                    (tenantData as any)?.setting?.heygen_avatar
                  }.mp4`}
                  loop
                  playsInline
                  autoPlay
                ></video>

                <IconNexaText neutral color="#FFFFFF" width={44} height={20} />
              </div>

              {isLoadingSession && !isCloseWhenLoading && (
                <div
                  onClick={(e) => e.stopPropagation()}
                  className="absolute rounded-[19px] z-50 top-12 right-20"
                  style={{
                    width: "98px",
                    height: "72px",
                    backgroundColor: "rgba(0, 0, 0, 0.5)",
                  }}
                >
                  <div className="relative -bottom-28 -right-38">
                    <LoaderFadeInOut />
                  </div>
                </div>
              )}
            </div>
          </div>
        </>
      )}

      {(stream || isLoadingSession) && !isCloseWhenLoading && (
        <div
          ref={containerRef}
          className={`${
            isScrolled ? "fixed w-[10px] h-[10px] z-30" : "w-full h-full"
          } inset-0 transition-all duration-500 ease-in-out opacity-100`}
        >
          <div
            ref={videoContainerRef}
            className={`${
              isScrolled
                ? "fixed bottom-20 right-20"
                : "relative w-full h-[calc(100vh-68px)]"
            } flex items-center justify-center`}
          >
            <div
              className={`flex ${
                (isScrolled && !showSidebar) || (!isScrolled && !showSidebar)
                  ? "w-full h-full rounded-xl"
                  : isScrolled && showSidebar
                  ? "w-full h-[calc(100vh-108px)] flex-col rounded-xl"
                  : "w-[70%]"
              } relative`}
              style={{
                boxShadow: "4px 4px 12px 0px #0000004D",
              }}
            >
              {isLoadingSession && (
                <div className={`${videoClass} bg-white`}>
                  <div
                    className={`${videoClass} flex flex-col justify-center items-center gap-24`}
                    style={{
                      background:
                        "linear-gradient(180deg, rgba(0, 0, 0, 0.2) 0%, rgba(255, 255, 255, 0) 15.5%)",
                    }}
                  >
                    <div className="relative">
                      <div className="absolute w-[148px] h-[148px] flex items-center justify-center">
                        <video
                          className="absolute w-100 h-100 object-cover rounded-full"
                          src={`/images/${
                            (tenantData as any)?.setting?.heygen_avatar
                          }.mp4`}
                          loop
                          playsInline
                          autoPlay
                          muted
                        ></video>
                      </div>

                      <motion.div
                        className="relative w-[148px] h-[148px]"
                        animate={{ rotate: 360 }}
                        transition={{
                          repeat: Infinity,
                          duration: 1.5,
                          ease: "linear",
                        }}
                      >
                        <svg className="w-full h-full" viewBox="0 0 100 100">
                          <circle
                            className="stroke-current text-violet_main_to_dark_purple_surface"
                            cx="50"
                            cy="50"
                            r="40"
                            fill="none"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeDasharray="220"
                            strokeDashoffset="50"
                          />
                        </svg>
                        <motion.div
                          className="absolute w-8 h-8 bg-violet_main_to_dark_purple_surface rounded-full"
                          initial={{ rotate: 0 }}
                          animate={{ rotate: 360 }}
                          transition={{
                            repeat: Infinity,
                            duration: 1.5,
                            ease: "linear",
                          }}
                          style={{ top: "16px", left: "calc(50% - 28px)" }}
                        />
                      </motion.div>
                    </div>

                    <p className="text-b1 font-medium text-[#817E8C]">
                      Memanggil NEXA...
                    </p>
                  </div>
                </div>
              )}

              {!isLoadingSession && (
                <>
                  {nxtxTenant ? (
                    <video
                      ref={mediaStream}
                      autoPlay
                      playsInline
                      onClick={(e) => {
                        e.stopPropagation();
                      }}
                      className={videoClass}
                      style={{
                        boxShadow: stream && "4px 4px 12px 0px #0000004D",
                      }}
                      id="sm-video"
                    ></video>
                  ) : (
                    <video
                      webkit-playsinline="true"
                      playsInline
                      onClick={(e) => {
                        e.stopPropagation();
                      }}
                      className={videoClass}
                      style={{
                        boxShadow: stream && "4px 4px 12px 0px #0000004D",
                      }}
                      id="sm-video"
                      ref={(ref) => {
                        mediaStream.current = ref;
                        if (ref && !isMediaReady) {
                          setIsMediaReady(true);
                        }
                      }}
                    />
                  )}
                </>
              )}

              {(stream || isLoadingSession) && showAdditionalContent && (
                <>
                  <motion.div
                    className={`absolute top-0 ${
                      !isScrolled ? "left-0" : "left-0 rounded-tl-xl"
                    } px-16 py-10 rounded-br-xl flex justify-center gap-8`}
                    style={{
                      background:
                        "linear-gradient(135deg, #883CFF 25%, #2F0F57 100%)",
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                    }}
                  >
                    <IconNexaText
                      neutral
                      color="#FFFFFF"
                      width={56}
                      height={24}
                    />
                  </motion.div>

                  {stream && !isScrolled && (
                    <div className="right-40 bottom-20 flex flex-col justify-end gap-12 items-end absolute z-50">
                      <p className="font-medium text-c2 text-right text-white_to_white">
                        Interaksi dengan NEXA terekam & hanya sebagai referensi.{" "}
                        <br />
                        <span
                          className="underline cursor-pointer"
                          onClick={() => {
                            // endSession();
                            // router.push("/terms-of-use");
                            window.open("/terms-of-use", "_blank");
                          }}
                        >
                          Terms
                        </span>
                      </p>
                    </div>
                  )}

                  {stream && isScrolled && (
                    <div
                      className="w-full py-6 rounded-b-xl flex justify-center gap-12 items-center absolute bottom-0 z-50"
                      style={{
                        backgroundColor: "#0000000F",
                        backdropFilter: isScrolled
                          ? "blur(100px)"
                          : "blur(24px)",
                      }}
                    >
                      <p className="font-light text-c2 text-center text-white_to_white">
                        Interaksi dengan NEXA terekam & hanya sebagai referensi.{" "}
                        <span
                          className="underline cursor-pointer"
                          onClick={() => {
                            // endSession();
                            // router.push("/terms-of-use");
                            window.open("/terms-of-use", "_blank");
                          }}
                        >
                          Terms
                        </span>
                      </p>
                    </div>
                  )}

                  {!isScrolled && (
                    <>
                      {(stream || isLoadingSession) && isShowModeInfo && (
                        <div className="absolute top-80 right-58 z-[100]">
                          <div className="relative max-w-[347px] text-black p-8 rounded-xl bg-[rgba(0,0,0,0.72)]">
                            <p className="text-b2 font-light text-white_to_white">
                              Assistant Mode
                            </p>
                            <div
                              className="absolute -top-[9.5px] right-44 w-0 h-0 border-l-[10px] border-l-transparent border-r-[10px] border-r-transparent"
                              style={{
                                borderBottom: "10px solid #000000CC",
                              }}
                            ></div>
                          </div>
                        </div>
                      )}

                      <motion.div
                        className={`absolute top-10 right-[90px] p-10 rounded-full cursor-pointer hover:bg-[rgba(0,0,0,0.08)]`}
                        onMouseEnter={() => setIsShowModeInfo(true)}
                        onMouseLeave={() => setIsShowModeInfo(false)}
                        onClick={(e) => {
                          e.stopPropagation();

                          handleMinimize(e);
                        }}
                      >
                        <Image
                          src={"/images/assistant.svg"}
                          alt="assistant"
                          width={24}
                          height={24}
                        />
                      </motion.div>

                      {(stream || isLoadingSession) && isShowEndButtonInfo && (
                        <div className="absolute top-80 right-36 z-[100]">
                          <div className="relative max-w-[347px] text-black p-8 rounded-xl bg-[rgba(0,0,0,0.72)]">
                            <p className="text-b2 font-light text-white_to_white">
                              Close
                            </p>
                            <div
                              className="absolute -top-[9.5px] right-18 w-0 h-0 border-l-[10px] border-l-transparent border-r-[10px] border-r-transparent"
                              style={{
                                borderBottom: "10px solid #000000CC",
                              }}
                            ></div>
                          </div>
                        </div>
                      )}

                      <motion.div
                        className={`absolute top-10 right-40 p-10 rounded-full cursor-pointer hover:bg-[rgba(0,0,0,0.08)]`}
                        onClick={endSession}
                        onMouseEnter={() => setIsShowEndButtonInfo(true)}
                        onMouseLeave={() => setIsShowEndButtonInfo(false)}
                      >
                        <IconClose size={24} color="#FFFFFF" />
                      </motion.div>
                    </>
                  )}

                  {stream && !isSmaller && (
                    <motion.div
                      onClick={(e) => {
                        e.stopPropagation();
                      }}
                      className={`absolute ${
                        isScrolled ? "bottom-22" : "bottom-0"
                      } h-64 w-full`}
                      style={{
                        backdropFilter: isScrolled
                          ? "blur(100px)"
                          : "blur(24px)",
                        backgroundColor: isScrolled ? "#FFFFFF14" : "#00000024",
                      }}
                    ></motion.div>
                  )}

                  {stream && !showSidebar && (
                    <div className="w-full overflow-x-auto absolute bottom-[92px] bg-transparent hide-scrollbar">
                      {keywordChipsData.length > 0 && (
                        <div
                          className={`flex items-center justify-center gap-4 ${
                            isScrolled ? "w-[40vw]" : "w-full"
                          }`}
                        >
                          {keywordChipsData.map((item, index) => (
                            <div
                              key={index}
                              onClick={() => {
                                handleInterrupt();
                                handleSubmit(true, item);
                              }}
                              className="rounded-full flex-shrink-0 py-8 px-12 cursor-pointer"
                              style={{
                                backdropFilter: "blur(40px)",
                                background: "#FFFFFF66",
                              }}
                            >
                              <p className="text-neutral-80 text-c1 font-light">
                                {item}
                              </p>
                            </div>
                          ))}
                        </div>
                      )}
                    </div>
                  )}

                  {stream && !isSmaller && (
                    <motion.div
                      className={`absolute ${
                        isScrolled
                          ? "left-6 bottom-[47px] opacity-50 hover:opacity-100 w-full gap-8 items-center"
                          : "left-40 bottom-22 gap-4 items-center justify-center"
                      } pt-10 rounded-full flex cursor-pointer`}
                      onClick={(e) => {
                        e.stopPropagation();

                        window.open("https://www.nxtx.ai", "_blank");
                      }}
                    >
                      <p className="text-white_to_white text-c1 font-light">
                        Powered by
                      </p>
                      <Image
                        src={"/images/logo-nxtx-dark.png"}
                        alt="nxtx"
                        width={69}
                        height={11}
                        className={
                          isScrolled ? "" : "flex-shrink-0 h-[11px] w-[69px]"
                        }
                      />
                    </motion.div>
                  )}

                  {isScrolled && (
                    <>
                      {(stream || isLoadingSession) && isShowModeInfo && (
                        <div className="absolute top-70 right-[34px] z-[100]">
                          <div className="relative max-w-[347px] text-black p-8 rounded-xl bg-[rgba(0,0,0,0.72)]">
                            <p className="text-b2 font-light text-white_to_white">
                              Focus Mode
                            </p>
                            <div
                              className="absolute -top-[9.5px] right-38 w-0 h-0 border-l-[10px] border-l-transparent border-r-[10px] border-r-transparent"
                              style={{
                                borderBottom: "10px solid #000000CC",
                              }}
                            ></div>
                          </div>
                        </div>
                      )}

                      <motion.div
                        className={`absolute ${
                          isScrolled && !isSmaller
                            ? "top-4"
                            : isScrolled && isSmaller
                            ? "bottom-8"
                            : "bottom-10"
                        } right-60 p-10 rounded-full cursor-pointer hover:bg-[rgba(0,0,0,0.08)]`}
                        onClick={handleFullScreen}
                        onMouseEnter={() => setIsShowModeInfo(true)}
                        onMouseLeave={() => setIsShowModeInfo(false)}
                      >
                        <Image
                          src={"/images/focus.svg"}
                          alt="focus"
                          width={24}
                          height={24}
                        />
                      </motion.div>

                      {(stream || isLoadingSession) && isShowEndButtonInfo && (
                        <div className="absolute top-70 right-12 z-[100]">
                          <div className="relative max-w-[347px] text-black p-8 rounded-xl bg-[rgba(0,0,0,0.72)]">
                            <p className="text-b2 font-light text-white_to_white">
                              Close
                            </p>
                            <div
                              className="absolute -top-[9.5px] right-16 w-0 h-0 border-l-[10px] border-l-transparent border-r-[10px] border-r-transparent"
                              style={{
                                borderBottom: "10px solid #000000CC",
                              }}
                            ></div>
                          </div>
                        </div>
                      )}

                      <motion.div
                        className={`absolute ${
                          isScrolled && !isSmaller
                            ? "top-4"
                            : isScrolled && isSmaller
                            ? "bottom-8"
                            : "bottom-10"
                        } right-16 p-10 rounded-full cursor-pointer hover:bg-[rgba(0,0,0,0.08)]`}
                        onClick={endSession}
                        onMouseEnter={() => setIsShowEndButtonInfo(true)}
                        onMouseLeave={() => setIsShowEndButtonInfo(false)}
                      >
                        <IconClose size={24} color="#FFFFFF" />
                      </motion.div>
                    </>
                  )}

                  {stream && (
                    <>
                      {isScrolled && showSidebar && (
                        <>
                          <button
                            id="mic-button"
                            onClick={
                              (!isMuted && nxtxTenant) ||
                              (isVoiceChatActive && !nxtxTenant)
                                ? handleCloseVoiceChat
                                : handleStartVoiceChat
                            }
                            className={`absolute top-[5%] left-1/2 -translate-x-1/2 translate-y-full opacity-100 bg-white_to_white bg-opacity-60 rounded-full hover:cursor-pointer p-10 transition-all duration-500 ease-in-out`}
                          >
                            <Image
                              src={`${
                                (!isMuted && nxtxTenant) ||
                                (isVoiceChatActive && !nxtxTenant)
                                  ? "/images/Microphone-On.svg"
                                  : "/images/Microphone-Off-Purple.svg"
                              }`}
                              alt="mic"
                              width={24}
                              height={24}
                              className="min-w-24 min-h-24"
                            />
                          </button>

                          {micIsLoading && (
                            <motion.div
                              onClick={(e) => e.stopPropagation()}
                              className={`absolute top-[5%] left-1/2 -translate-x-1/2 translate-y-full rounded-full z-50`}
                              style={{
                                width: "44px",
                                height: "44px",
                                backgroundColor: "rgba(0, 0, 0, 0.5)",
                              }}
                            >
                              <motion.div className="relative -bottom-10 -right-18">
                                <LoaderFadeInOut />
                              </motion.div>
                            </motion.div>
                          )}

                          <motion.div
                            className={`absolute top-[20%] opacity-50 hover:opacity-100 w-full gap-8 justify-center items-center pt-10 rounded-full flex cursor-pointer`}
                            onClick={(e) => {
                              e.stopPropagation();

                              window.open("https://www.nxtx.ai", "_blank");
                            }}
                          >
                            <p className="text-white_to_white text-c1 font-light">
                              Powered by
                            </p>
                            <Image
                              src={"/images/logo-nxtx-dark.png"}
                              alt="nxtx"
                              width={66}
                              height={11}
                              className={
                                isScrolled
                                  ? ""
                                  : "flex-shrink-0 h-[11px] w-[69px]"
                              }
                            />
                          </motion.div>
                        </>
                      )}

                      <motion.div
                        className={`absolute ${
                          isScrolled
                            ? "bottom-[35px] right-6"
                            : "bottom-10 left-1/2 -translate-x-1/2"
                        } flex items-center gap-4 transition-all z-30`}
                      >
                        <motion.div
                          className={`bg-white_to_white ${
                            isScrolled ? "w-[8.5vw]" : "w-[22vw] gap-2"
                          } rounded-full flex items-center transition-all duration-500 z-30`}
                        >
                          {remainingDuration <= 120 &&
                            remainingDuration >= 0 && (
                              <motion.div
                                className="border-2 border-white_to_white rounded-full cursor-pointer py-12 px-12 flex justify-between items-center gap-8 text-white_to_white text-b2 font-medium"
                                style={{
                                  backgroundColor: "#D0375CCC",
                                }}
                                onClick={(e) => {
                                  e.stopPropagation();

                                  setShowLimitDesc(!showLimitDesc);
                                }}
                              >
                                {formatTime(remainingDuration)}

                                <Image
                                  className="min-h-16 min-w-16"
                                  src={"/images/countdown-info.svg"}
                                  alt="countdown"
                                  width={16}
                                  height={16}
                                />
                              </motion.div>
                            )}

                          {nxtxTenant ? (
                            <VisualAudioContext.Provider value={isMuted}>
                              <AudioVisualizerNxtx
                                customClass={`w-full ${
                                  !(
                                    remainingDuration <= 120 &&
                                    remainingDuration >= 0
                                  ) && "translate-x-[5%]"
                                } flex justify-center items-center gap-8 ${
                                  isScrolled ? "" : "px-16"
                                } py-10 rounded-full bg-transparent`}
                              />
                            </VisualAudioContext.Provider>
                          ) : (
                            <AudioVisualizer
                              volumes={volumes}
                              customClass={`w-full ${
                                !(
                                  remainingDuration <= 120 &&
                                  remainingDuration >= 0
                                ) && "translate-x-[5%]"
                              } flex justify-center items-center gap-8 ${
                                isScrolled ? "" : "px-16"
                              } py-10 rounded-full bg-transparent`}
                            />
                          )}

                          <div className="relative">
                            <button
                              // disabled={disabledMic}
                              id="mic-button"
                              onClick={
                                (!isMuted && nxtxTenant) ||
                                (isVoiceChatActive && !nxtxTenant)
                                  ? handleCloseVoiceChat
                                  : handleStartVoiceChat
                              }
                              className={`opacity-100 hover:cursor-pointer p-8 transition-all duration-500 ease-in-out`}
                            >
                              <Image
                                src={`${
                                  (!isMuted && nxtxTenant) ||
                                  (isVoiceChatActive && !nxtxTenant)
                                    ? "/images/Microphone-On.svg"
                                    : "/images/Microphone-Off-Purple.svg"
                                }`}
                                alt="mic"
                                width={24}
                                height={24}
                                className="min-w-24 min-h-24"
                              />
                            </button>

                            {micIsLoading && (
                              <motion.div
                                onClick={(e) => e.stopPropagation()}
                                className={`absolute top-0 right-0 rounded-full z-50`}
                                style={{
                                  width: "40px",
                                  height: "40px",
                                  backgroundColor: "rgba(0, 0, 0, 0.5)",
                                }}
                              >
                                <motion.div className="relative -bottom-10 -right-18">
                                  <LoaderFadeInOut />
                                </motion.div>
                              </motion.div>
                            )}
                          </div>
                        </motion.div>

                        <div className="relative">
                          <motion.div
                            className={`${
                              showSidebar
                                ? // chatMode === "text_mode"
                                  // ? "bg-purple50_to_purple50"
                                  "bg-white_to_white"
                                : "bg-white_to_white bg-opacity-50"
                            } rounded-full flex relative items-center gap-2 transition-all duration-500 z-30`}
                          >
                            <button
                              onClick={toggleSidebar}
                              id="mode-button"
                              className={`opacity-100 hover:cursor-pointer p-8 transition-all duration-500 ease-in-out`}
                              onMouseEnter={() =>
                                setIsShowConversationInfo(true)
                              }
                              onMouseLeave={() =>
                                setIsShowConversationInfo(false)
                              }
                            >
                              <Image
                                src="/images/conversation.svg"
                                alt="conversation"
                                width={24}
                                height={24}
                              />
                            </button>

                            {isShowConversationInfo && (
                              <div
                                className={`absolute bottom-80 ${
                                  isScrolled ? "right-0" : "-right-14"
                                } z-[100]`}
                              >
                                <div
                                  className="relative min-w-[80px] text-black p-8 rounded-xl"
                                  style={{
                                    backgroundColor: "#000000CC",
                                  }}
                                >
                                  <p
                                    className="text-b2 font-light"
                                    style={{
                                      color: "#FFFFFF",
                                    }}
                                  >
                                    Transkripsi
                                  </p>
                                  <div
                                    className={`absolute -bottom-[9.5px] ${
                                      isScrolled
                                        ? "right-20"
                                        : "right-1/2 translate-x-1/2"
                                    } w-0 h-0 border-l-[10px] border-l-transparent border-r-[10px] border-r-transparent`}
                                    style={{
                                      borderTop: "10px solid #000000CC",
                                    }}
                                  ></div>
                                </div>
                              </div>
                            )}
                          </motion.div>
                        </div>
                      </motion.div>
                    </>
                  )}

                  {showLimitDesc &&
                    Limit(
                      `absolute bottom-88 ${isScrolled && "mx-4"} max-w-[40vw]`,
                      "Kuota NEXA Hampir Habis!",
                      <p className="font-light text-b2 text-black_to_black">
                        Agar diskusi interaktif dengan AI dapat tetap berjalan
                        tanpa hambatan, ajukan peningkatan limit sekarang!
                      </p>,
                      setShowLimitDesc,
                      isIncreaseLimit,
                      isRequestSent,
                      setIsRequestSent,
                      limitChecked,
                      setLimitChecked,
                      showToast,
                      isScrolled,
                      handleRequestQuota,
                      currentUser,
                      dataAvatar,
                      maxDuration
                    )}
                </>
              )}

              {stream && isScrolled && showSidebar && (
                <div className="relative rounded-b-xl overflow-auto hide-scrollbar bg-white h-full z-[100]">
                  <BottomNavMobile
                    nxtxTenant={nxtxTenant}
                    sendInterrupt={sendInterrupt}
                    sendText={sendText}
                    keywordChipsData={keywordChipsData}
                    handleSubmit={handleSubmit}
                    handleInterrupt={handleInterrupt}
                    isLoadingRepeat={isLoadingRepeat}
                    isQuizStarted={isQuizStarted}
                    setIsQuizStarted={setIsQuizStarted}
                    saveChat={saveChat}
                    filterChatWithQuestion={filterChatWithQuestion}
                    textValue={textValue}
                    setTextValue={setTextValue}
                    handleSpeakText={handleSpeakText}
                    showSidebar={showSidebar}
                    toggleSidebar={toggleSidebar}
                    chat={chat}
                    lastDisplayedDate={lastDisplayedDate}
                    currentUser={currentUser}
                    handleCopyText={handleCopyText}
                    copySuccess={copySuccess}
                    chatEndRef={chatEndRef}
                    showSummarySidebar={showSummarySidebar}
                    toggleSummarySidebar={toggleSummarySidebar}
                    activeTab={activeTab}
                    setActiveTab={setActiveTab}
                    stream={stream}
                    summaryRecap={summaryRecap}
                    summaryEndRef={summaryEndRef}
                    showQuizSidebar={showQuizSidebar}
                    toggleQuizSidebar={toggleQuizSidebar}
                    customClassQuiz="relative h-full w-full px-16 pb-72 pt-58 transition-all duration-700 ease-in-out"
                    customClassTranscript="relative h-full w-full px-16 pb-48 pt-48 transition-all duration-700 ease-in-out"
                    customClassSummary=""
                  />
                </div>
              )}
            </div>

            {stream && !isScrolled && (
              <motion.div
                variants={sidebarAnimate}
                animate={showSidebar ? "open" : "closed"}
                className={`flex relative h-full bg-white`}
              >
                <SidebarDesktop
                  nxtxTenant={nxtxTenant}
                  sendInterrupt={sendInterrupt}
                  sendText={sendText}
                  keywordChipsData={keywordChipsData}
                  handleSubmit={handleSubmit}
                  handleInterrupt={handleInterrupt}
                  isLoadingRepeat={isLoadingRepeat}
                  isQuizStarted={isQuizStarted}
                  setIsQuizStarted={setIsQuizStarted}
                  saveChat={saveChat}
                  filterChatWithQuestion={filterChatWithQuestion}
                  textValue={textValue}
                  setTextValue={setTextValue}
                  handleSpeakText={handleSpeakText}
                  showSidebar={showSidebar}
                  toggleSidebar={toggleSidebar}
                  chat={chat}
                  lastDisplayedDate={lastDisplayedDate}
                  currentUser={currentUser}
                  handleCopyText={handleCopyText}
                  copySuccess={copySuccess}
                  chatEndRef={chatEndRef}
                  showSummarySidebar={showSummarySidebar}
                  toggleSummarySidebar={toggleSummarySidebar}
                  activeTab={activeTab}
                  setActiveTab={setActiveTab}
                  stream={stream}
                  summaryRecap={summaryRecap}
                  summaryEndRef={summaryEndRef}
                  showQuizSidebar={showQuizSidebar}
                  toggleQuizSidebar={toggleQuizSidebar}
                  customClassTranscript="w-full mb-20 bottom-70 right-40 px-16 pb-20 pt-50 transition-all duration-700 ease-in-out"
                  customClassSummary="w-full mb-20 bottom-70 right-40 px-16 pb-20 pt-50 transition-all duration-700 ease-in-out"
                />
              </motion.div>
            )}
          </div>
        </div>
      )}
    </>
  );
};
